
(function() {
  'use strict';

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ============================================
  // 0. DYNAMIC YEAR + IMAGE ERROR HANDLER
  // ============================================
  const yearEl = document.getElementById('year');
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  // Mark broken images so the brass-tinted fallback is visible
  document.querySelectorAll('img').forEach(img => {
    img.addEventListener('error', () => {
      img.classList.add('img--broken');
      img.alt = '\u26A0 Image failed to load: ' + (img.alt || '');
    }, { once: true });
  });

  // ============================================
  // 1. SCROLL PROGRESS BAR + RAF-THROTTLED SCROLL HANDLER
  // ============================================
  const progressBar = document.getElementById('scroll-progress');
  let scrollTicking = false;
  let lastScrollY = 0;

  function onScroll() {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(() => {
      const y = window.scrollY;
      // progress bar
      if (progressBar) {
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        const pct = docHeight > 0 ? (y / docHeight) : 0;
        progressBar.style.transform = `scaleX(${pct})`;
      }
      // strand parallax
      if (strandBg) {
        const rect = strandSection.getBoundingClientRect();
        const center = rect.top + rect.height / 2 - window.innerHeight / 2;
        const offset = -center * 0.15;
        strandBg.style.transform = `scale(${1 + Math.abs(center) * 0.0003}) translateY(${offset}px)`;
      }
      // press parallax
      if (pressBg) {
        const rect = pressSection.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          const p = 1 - (rect.top + rect.height) / (window.innerHeight + rect.height);
          pressBg.style.transform = `scale(${1.05 + p * 0.05}) translateY(${-p * 30}px)`;
        }
      }
      // growth crossfade
      if (growthSection) {
        const rect = growthSection.getBoundingClientRect();
        const total = growthSection.offsetHeight - window.innerHeight;
        if (total > 0) {
          const scrolled = Math.max(0, -rect.top);
          const progress = Math.min(1, scrolled / total);
          if (progress > 0.4) {
            if (growthForest) growthForest.classList.add('is-visible');
            if (growthTagline) growthTagline.classList.add('is-visible');
            if (growthScroll) growthScroll.classList.add('is-hidden');
          } else {
            if (growthForest) growthForest.classList.remove('is-visible');
            if (growthTagline) growthTagline.classList.remove('is-visible');
            if (growthScroll) growthScroll.classList.remove('is-hidden');
          }
        }
      }
      // cat section screen index
      if (catSection) {
        try {
          const rect = catSection.getBoundingClientRect();
          const vh = window.innerHeight;
          const inView = rect.top < vh * 0.5 && rect.bottom > vh * 0.5;
          catSection.classList.toggle('cat--in-view', inView);
          const onPos = catScreens.length > 0 && lastCatIdx >= 3;
          catSection.classList.toggle('cat--on-pos', onPos);
        } catch (e) { /* silent */ }
      }
      lastScrollY = y;
      scrollTicking = false;
    });
  }

  // ============================================
  // 2. INTERSECTION OBSERVER — reveal scenes & all reveal-blocks
  // ============================================
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      // Reveal all child .reveal-block elements (growth numbers, strand/press titles, captions)
      const revealBlocks = entry.target.querySelectorAll('.reveal-block');
      revealBlocks.forEach((el, i) => {
        setTimeout(() => el.classList.add('is-visible'), i * 80);
      });
      // Stagger child pillars/layers/rows
      const staggers = entry.target.querySelectorAll('.resin__pillar, .forming__layer, .reveal__pillar, .factory__num-item, .bench__row, .strength__num, .strength__benefit');
      staggers.forEach((el, i) => {
        setTimeout(() => el.classList.add('is-visible'), i * 120);
      });
      revealObserver.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  // Observe all scenes + their .reveal-block descendants
  document.querySelectorAll('.scene, .cat, .bench, .cta, .strength').forEach(el => {
    revealObserver.observe(el);
    el.querySelectorAll('.reveal-block').forEach(b => revealObserver.observe(b));
  });

  // If reduced motion, skip animations: show everything immediately
  if (prefersReducedMotion) {
    document.querySelectorAll('.reveal-block, .resin__pillar, .forming__layer, .reveal__pillar, .factory__num-item, .bench__row, .strength__num, .strength__benefit, .scene, .cat, .bench, .cta').forEach(el => el.classList.add('is-visible'));
    if (progressBar) progressBar.style.transform = 'scaleX(0)';
  }

  // ============================================
  // 3. PERFORMANCE COUNTERS
  // ============================================
  function runCounter(row) {
    const valEl = row.querySelector('.perf__val');
    if (!valEl || row.dataset.counted) return;
    row.dataset.counted = 'true';
    row.classList.add('is-visible');

    const target = parseFloat(row.dataset.target);
    const prefix = row.dataset.prefix || '';
    const duration = prefersReducedMotion ? 0 : 1600;
    const start = performance.now();
    const isThickness = target < 100;

    function tick(now) {
      const elapsed = now - start;
      const t = Math.min(1, elapsed / Math.max(duration, 1));
      const eased = 1 - Math.pow(1 - t, 3); // easeOutCubic
      const v = target * eased;
      if (isThickness) {
        valEl.textContent = prefix + Math.round(v);
      } else {
        valEl.textContent = prefix + Math.round(v).toLocaleString();
      }
      if (t < 1) requestAnimationFrame(tick);
      else {
        // Final value: use the actual target, not hardcoded '0'
        const final = isThickness ? Math.round(target) : target.toLocaleString();
        valEl.textContent = prefix + final;
      }
    }
    requestAnimationFrame(tick);
  }

  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        runCounter(entry.target);
        counterObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });
  document.querySelectorAll('.perf__row').forEach(row => counterObserver.observe(row));

  // ============================================
  // 4. BENCHMARK BARS
  // For "lower is better" rows, attribute the larger absolute value
  // to the WORSE performer (OSB4 in this case) so visual length
  // matches reality.
  // ============================================
  const benchObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const row = entry.target;
      if (row.dataset.animated) return;
      row.dataset.animated = 'true';
      const bamosbPct = parseFloat(row.dataset.bamosb);
      const osb4Pct = parseFloat(row.dataset.osb4);
      const isInverse = row.dataset.inverse === 'true';
      const bamosbFill = row.querySelector('.bench__bar:nth-child(1) .bench__bar-fill');
      const osb4Fill = row.querySelector('.bench__bar:nth-child(2) .bench__bar-fill');
      // Normalize so the larger of the two always maps to 100% (so we
      // get a visible differentiation), then in inverse mode we still
      // attribute the longer bar to the worse performer.
      const max = Math.max(bamosbPct, osb4Pct);
      const scale = max > 0 ? 100 / max : 0;
      const bamosbWidth = bamosbPct * scale;
      const osb4Width = osb4Pct * scale;
      // For "lower is better", swap: BAMOSB bar length = OSB4's, OSB4 bar = BAMOSB's
      if (isInverse) {
        if (bamosbFill) bamosbFill.style.width = osb4Width + '%';
        if (osb4Fill) osb4Fill.style.width = bamosbWidth + '%';
      } else {
        if (bamosbFill) bamosbFill.style.width = bamosbWidth + '%';
        if (osb4Fill) osb4Fill.style.width = osb4Width + '%';
      }
    });
  }, { threshold: 0.3 });
  document.querySelectorAll('.bench__row').forEach(row => benchObserver.observe(row));

  // ============================================
  // 5. GROWTH STORY (Scene 02) — elements referenced in scroll handler
  // ============================================
  const growthSection = document.getElementById('growth-section');
  const growthForest = document.getElementById('growth-forest');
  const growthTagline = document.getElementById('growth-tagline');
  const growthScroll = document.getElementById('growth-scroll');

  // ============================================
  // 6. CATEGORY DEFINITION (Scene 09) — sticky scroll progress
  // ============================================
  const catSection = document.getElementById('cat-section');
  const catScreens = catSection ? catSection.querySelectorAll('.cat__screen') : [];
  const catDots = catSection ? catSection.querySelectorAll('.cat__dot') : [];
  const catNav = document.getElementById('cat-nav');
  const catNavItems = catNav ? catNav.querySelectorAll('.cat__nav-item') : [];
  const catCounterCurrent = document.getElementById('cat-counter-current');
  const catStepCurrent = document.getElementById('cat-step-current');
  const catStepFill = document.getElementById('cat-step-fill');
  const catPersistent = catSection ? catSection.querySelector('.cat__persistent') : null;
  let lastCatIdx = 0;

  // Click-to-jump: clicking a nav item scrolls to that screen
  if (catNav) {
    catNavItems.forEach((item) => {
      item.addEventListener('click', () => {
        const idx = parseInt(item.dataset.screen, 10);
        if (isNaN(idx) || !catSection) return;
        const screen = catScreens[idx];
        if (!screen) return;
        screen.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'center' });
      });
    });
  }

  // IntersectionObserver: switch active screen by which one is in viewport
  if (catSection && catScreens.length > 0) {
    const catObs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0.55) {
          const idx = parseInt(entry.target.dataset.screen, 10);
          if (isNaN(idx) || idx === lastCatIdx) return;
          lastCatIdx = idx;
          catScreens.forEach((s, i) => s.classList.toggle('is-active', i === idx));
          catNavItems.forEach((n, i) => n.classList.toggle('is-active', i === idx));
          if (catCounterCurrent) catCounterCurrent.textContent = String(idx + 1).padStart(2, '0');
          catSection.classList.toggle('cat--on-pos', idx >= 3);
        }
      });
    }, { threshold: [0.55] });
    catScreens.forEach(s => catObs.observe(s));
  }

  // ============================================
  // 7. STRAND SCENE — parallax elements
  // ============================================
  const strandSection = document.querySelector('.strand');
  const strandBg = strandSection ? strandSection.querySelector('.strand__bg img') : null;

  // ============================================
  // 8. PRESS SCENE — parallax elements
  // ============================================
  const pressSection = document.querySelector('.press');
  const pressBg = pressSection ? pressSection.querySelector('.press__bg img') : null;

  // ============================================
  // 9. SINGLE SCROLL LISTENER (rAF-throttled)
  // ============================================
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ============================================
  // 10. TOP NAV — smooth scroll to named anchors
  // ============================================
  document.querySelectorAll('.topnav a[data-scroll]').forEach(a => {
    a.addEventListener('click', (e) => {
      const target = document.getElementById(a.dataset.scroll);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
    });
  });

  // Top nav auto-hide on scroll down, show on scroll up
  const topnav = document.getElementById('topnav');
  let topnavHidden = false;
  if (topnav) {
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      const shouldHide = y > 400 && y > lastScrollY;
      if (shouldHide !== topnavHidden) {
        topnavHidden = shouldHide;
        topnav.classList.toggle('topnav--hidden', shouldHide);
      }
    }, { passive: true });
  }
})();


// ── Mobile Burger Menu ──
(function() {
  var burger = document.getElementById('burgerBtn');
  var menu   = document.querySelector('.topnav__menu');
  if (!burger || !menu) return;

  burger.addEventListener('click', function() {
    var open = menu.classList.toggle('is-open');
    burger.classList.toggle('is-active', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  });

  // Close on nav link click
  menu.querySelectorAll('a').forEach(function(a) {
    a.addEventListener('click', function() {
      menu.classList.remove('is-open');
      burger.classList.remove('is-active');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  });
})();
